"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvancedAction = AdvancedAction;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const AdvancedActions_module_scss_1 = __importDefault(require("./AdvancedActions.module.scss"));
function AdvancedAction({ icon, undo, href, onClick, title, }) {
    const classes = (0, classnames_1.default)(AdvancedActions_module_scss_1.default.action, {
        [AdvancedActions_module_scss_1.default[`action--undo`]]: undo
    });
    const Element = href ? `a` : `button`;
    const actionProps = href
        ? { href, target: '_self' }
        : { onClick };
    return (0, jsx_runtime_1.jsx)(Element, { className: classes, title: title, ...actionProps, children: (0, jsx_runtime_1.jsx)("span", { className: AdvancedActions_module_scss_1.default.actionIcon, children: icon }) });
}
AdvancedAction.propTypes = {
    /** Material Icon name */
    icon: prop_types_1.default.string,
    /** Adds "undo"/"cancel" on top of primary icon */
    undo: prop_types_1.default.bool,
    /** Renders element as anchor tag with href location */
    href: prop_types_1.default.string,
    /** Explanatory text to appear on hover */
    title: prop_types_1.default.string,
    /** Renders element as button, along with the method that will be run when the user clicks. */
    onClick: prop_types_1.default.func
};
//# sourceMappingURL=AdvancedAction.js.map